import ELEMENT from 'element-ui/lib/element-ui.common';
import { lang, ElementLibs } from './element';
import lib from './libs';
import config from './config';
import install from './install';
import use from './interface';
import components from './components';
import pkg from '../package.json';
import { stickyContainer, stickyItem } from 'vue-xpc/src/mixins/sticky';

import './assets';
import './element-polyfill';

window.rt = { ...window.rt, ...lib };

const rtXpc = {
  install,
  use: use,
  lib: lib,
  config: config,
  version: pkg.version,
  components: components,
  stickyContainer,
  stickyItem,
  ...components.reduce(
    (res, item) => ({
      ...res,
      [item.name]: item.component
    }),
    {}
  )
};

// ************* important start *************
// 注：此处代码不能直接合并至rtXpc对象中，会导致yarn lib过程中无法将ElementUI代码打包至项目文件中，原因暂时不明
ELEMENT.lang = lang;

rtXpc.ELEMENT = ELEMENT;

rtXpc.ElementLibs = ElementLibs;
// ************* important end *************
export default rtXpc;



// WEBPACK FOOTER //
// ./~/vue-xpc/src/index.js